const { Stripe } = window

const { REACT_APP_STRIPE_PUBLISHABLE_KEY } = process.env

var stripe = Stripe(REACT_APP_STRIPE_PUBLISHABLE_KEY)

export const redirectToCheckout = (sessionId) => {
  return stripe.redirectToCheckout({ sessionId })
}
